import Markdown from 'react-markdown';
import styled from 'styled-components';

import { modalHeading, paragraph, smallSpacedHeading, spacedHeading } from '../../../theme/typography';
import { media } from '../../../theme/media';
import { getUnderLine } from '../../../theme/mixins';

export const Container = styled(Markdown)`
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
  }

  h1,
  h2 {
    text-align: center;
  }

  h1 {
    ${modalHeading};
  }

  h2 {
    text-transform: uppercase;
    ${smallSpacedHeading};
    margin-top: 16px;
  }

  h4 {
    ${spacedHeading};
  }

  h1 + h3,
  h2 + h3 {
    margin-top: 32px;
  }

  h3 + p {
    margin-top: 8px;
  }

  h4 + p {
    ${media.tablet`
      margin-top: 16px;
    `};
  }

  p + h3 {
    margin-top: 16px;
  }

  h4,
  p {
    ${paragraph};
  }

  h3 {
    display: inline-block;
    margin-right: 8px;
    ${media.tablet`
      transform: translateX(-48px);
      width: 0;
      margin-right: 0;
    `};
  }

  h3 + h3 {
    display: inline;
    width: auto;
    transform: none;
    ${media.tablet`
      display: inline-block;
    `};
  }

  h4 {
    margin-top: 16px;

    ${media.tablet`
      position: absolute;
      transform: translateX(-48px);
    `};
  }

  strong {
    font-weight: normal;
    font-style: italic;
  }

  ul {
    margin: 0;
    list-style: disc !important;
    padding-left: 56px;

    li:before {
      content: attr(data-label);
      position: absolute;
      transform: translateX(-56px);
    }
  }

  a {
    ${getUnderLine('primary')};
  }
`;
